<template>
  	<ul class="AlgoliaHits grid grid--medium">
      	<li class="grid__item smart-one-whole one-half lap-and-up-one-third" v-for="item in filteredItems" :key="item.objectID">
            <AlgoliaSearchHit :item="item" />
      	</li>
  	</ul>
</template>

<script>
export default {
  	props: {
		items: {
			type: Array,
			required: true
		},
		searchCategory: {
			type: String,
			required: true
		}
    },

	computed: {
		filteredItems() {
			return this.items.filter(item => item.title !== this.searchCategory && item.title !== 'Stay');
		}
	}
}
</script>

<style lang="scss" scoped>
  ::v-deep h6 {
      @include media-query(palm) {
          font-size: 1.5rem!important;
      }
  }
</style>
